{
  "confirm": {
    "confirmToDeleteMediaAndRemoveFromProjects": "Löschen und aus Projekt entfernen | Löschen und aus Projekten entfernen",
    "unsavedChanges": "Nicht gespeicherte Änderungen!",
    "areYouSureYouWantToRemovePage": "'{pageName}' löschen.",
    "deleteStyle": "Stil löschen?",
    "deleteMedia": "Medien löschen?",
    "deleteMediaImplications": "Löschen und aus Projekten entfernen?",
    "deletePlayer": "Player löschen?",
    "deletePlayerImplications": "Diese Aktion entfernt den Player aus Ihrem ARYA-Konto und löscht alle Einstellungen, die sich auf diesen Player beziehen, einschließlich aller geplanten Abläufe.",
    "permanentlyDeleteTheUserAccount": "Konto löschen",
    "removeTemplate": "Vorlage entfernen",
    "removeTemplateDesc": "Möchten Sie diese Vorlage aus diesem Stil entfernen?",
    "removeTheMediaFromTheSchedule": "Aus dem Zeitplan löschen.",
    "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Medien löschen",
    "mediaUsedInProject": "In Projekt verwendete Medien | In Projekten verwendete Medien",
    "confirmPassword": "Passwort bestätigen",
    "changeEmail": "E-Mail ändern",
    "deleteOrder": "Bestellung löschen",
    "deleteTag": "Tag löschen?",
    "deletePopId": "PoP-ID löschen?",
    "deleteUser": "Benutzer löschen?",
    "deleteAccount": "Konto löschen?",
    "leaveAccount": "Konto verlassen?",
    "deleteCanvasResolution": "Canvas-Auflösung löschen?",
    "downloadLicense": "Lizenz herunterladen?",
    "cancelOrder": "Bestellung stornieren?",
    "removeAccessFromArya": "Zugriff von ARYA entfernen?",
    "deleteTemplate": "Vorlage löschen?"
  },
  "signinup": {
    "new": "Neu bei {productNameShort}?",
    "newUser": "Neuer Benutzer"
  },
  "label": {
    "aryaAccountID": "Arya-Konto-ID",
    "accountId": "Konto-ID",
    "admin": "Admin",
    "addPlayer": "Player hinzufügen",
    "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "Der Code {code} wurde bereits in einem anderen Konto zugewiesen.",
    "assignCodeHasAlreadyBeenAssignedErrorMessage": "Der Code {code} wurde bereits zugewiesen.",
    "account": "Konto | Konten",
    "accountInfo": "Kontoinformationen",
    "accountInformation": "Kontoinformationen",
    "accountName": "Kontoname",
    "accountPlan": "Kontoplan",
    "accountCorrespondent": "Kontokorrespondent",
    "accountIsDeleted": "Konto wurde gelöscht",
    "activate": "aktivieren",
    "address": "Adresse",
    "alert": "Warnung | Warnungen",
    "amount": "Menge",
    "apply": "anwenden",
    "assign": "Zuweisung | Zuweisungen",
    "audio": "Audio",
    "auto": "Auto",
    "basic": "Basis",
    "bannerText1": "Geplante Wartung",
    "bannerText2": "Am {date} um {time} werden für etwa {approximateHours} Stunden planmäßige Wartungsarbeiten durchgeführt. Wir entschuldigen uns für jegliche Unannehmlichkeiten, die während dieser Zeit ggf. entstehen.",
    "bannerText3": "Während der Wartungsarbeiten können an {productName} keine Inhaltsänderungen vorgenommen werden, aber die Player werden ihre Inhalte weiterhin anzeigen.",
    "buy": "kaufen",
    "billing": "Abrechnung",
    "billingDetails": "Rechnungsdetails",
    "comment": "Kommentar",
    "companyInformation": "Informationen zur Firma",
    "contentNotSupported": "Inhalt nicht unterstützt, hier klicken, um weitere Informationen zu erhalten...",
    "copy": "Kopie | Kopien",
    "configPending": "KONFIG AUSSTEHEND",
    "configError": "KONFIG-FEHLER",
    "credentials": "Anmeldedaten",
    "credentialsNotValid": "Anmeldedaten nicht gültig",
    "createStyle": "Stil erstellen",
    "createUserExistErrorMessage": "{email} ist bereits Mitglied dieses Kontos.",
    "createUserLimitReached": "Benutzerlimit erreicht",
    "creditCard": "Kreditkarte",
    "download": "Herunterladen",
    "extended": "erweitert",
    "expirationDate": "Verfallsdatum",
    "expires": "läuft ab",
    "language": "Sprache",
    "learnMore": "Weitere Informationen",
    "leaveAccount": "Konto verlassen",
    "leaveAccountWithOnlyOneUserMessage": "Sie können das Konto nicht verlassen, da Sie der einzige Benutzer des Kontos sind.",
    "leaveAccountTheOnlyAdminInTheAccountMessage": "Sie können das Konto nicht verlassen, da Sie der einzige Administrator des Kontos sind.",
    "leaveAccountImplicationsCommonMessage": "Dadurch werden Sie aus diesem Konto entfernt.",
    "license": "Lizenz",
    "limited": "begrenzt",
    "location": "Standort",
    "login": "Anmelden",
    "loginError": "Ein Fehler ist aufgetreten. Anmeldung ist derzeit nicht möglich. Bitte versuchen Sie es später erneut oder wenden Sie sich an Ihren Administrator.",
    "loginWith": "Anmelden mit",
    "loginString2": "Inhalt sofort auf dem Bildschirm. Kostenlos.",
    "loginString3": "Einfachheit trifft auf Digital Signage.",
    "loginString4": "Feature-Sets nahtlos bestellen und aktivieren",
    "loginOKStringTitle2": "Einfachheit trifft auf Smart Sync.",
    "loginOKStringDesc1": "Anpassen. Planen. Priorisieren.",
    "loginOKStringDesc2": "Tagging. Smart Sync. Bei Bedarf Alarmhinweise.",
    "loginOKString4": "Nächster Schritt. Schnelle Player-Einrichtung.",
    "loginOKString5": "Sie benötigen lediglich die Seriennummer Ihres Players.",
    "loginOKQuotaWarnMain": "Freier Speicher {percentage}% voll.",
    "loginOKQuotaWarnSub": "Führen Sie ein Upgrade auf {plan} durch, um 10 GB Speicherplatz pro Player, vollständig anpassbare Vorlagen und Warnmeldungen, Smart Tags, 10 Benutzer und vieles mehr zu erhalten.",
    "loginOKQuotaReachedMain": "Freier Speicher {percentage}% voll.",
    "loginOKQuotaReachedSub": "Führen Sie ein Upgrade auf {plan} durch, um 10 GB Speicherplatz pro Player, vollständig anpassbare Vorlagen und Warnmeldungen, Smart Tags, 10 Benutzer und vieles mehr zu erhalten.",
    "loginOKQuotaExcededMain": "Freier Speicher voll.",
    "loginOKQuotaExcededSub": "Führen Sie ein Upgrade auf {plan} durch, um 10 GB Speicherplatz pro Player, vollständig anpassbare Vorlagen und Warnmeldungen, Smart Tags, 10 Benutzer und vieles mehr zu erhalten.",
    "logoutOKStringTitle1": "SIE SIND JETZT AUSGELOGGT",
    "logoutOKStringDesc1": "Sie können sich erneut anmelden, indem Sie auf die Schaltfläche unten klicken.",
    "notice": "Hinweis",
    "playerSetupString1": "Erstellen Sie Ihr Projekt.",
    "playerSetupString2": "Es ist super einfach. Es ist super schnell.",
    "playerSetupString3": "label.playerSetupString3",
    "payments": "Zahlungen",
    "pageNotFound": "Es tut uns Leid, die Seite wurde nicht gefunden.",
    "plan": "Plan | Pläne",
    "popIdentifier": "PoP-KENNUNG",
    "postalCode": "Postleitzahl",
    "purchasePlanUpgradeSuccessMain": "Willkommen zu {plan}",
    "purchasePlanDowngradeSuccessMain": "Konto wurde auf {planName} herabgestuft",
    "loggedOffInFewSeconds": "Sie werden in einigen Sekunden abgemeldet",
    "termsOfServiceString1": "Nutzungsbedingungen",
    "termsOfServiceString2": "Zuletzt aktualisiert am: 9. Januar 2019",
    "termsOfServiceString3": "Bitte laden Sie folgendes Dokument herunter und lesen Sie es durch",
    "termsOfServiceString4": "NUTZUNGSBEDINGUNGEN",
    "termsOfServiceString5": "DATENSCHUTZBESTIMMUNGEN",
    "termsOfServiceString6": "Wählen Sie ZUSTIMMEN aus, um fortzufahren.",
    "accept": "akzeptieren",
    "all": "Alles",
    "allPlayers": "Alle Player",
    "add": "Hinzufügen",
    "setPassword": "Bestätigen",
    "cancel": "abbrechen",
    "canvasSize": "Größe der Arbeitsfläche: {size} Pixel",
    "canvasExistsError": "Leinwand mit dieser Größe existiert bereits",
    "cardType": "Kartentyp",
    "cardNumber": "Kartennummer",
    "change": "ändern",
    "clickToEdit": "zum Bearbeiten anklicken",
    "city": "Stadt",
    "color": "Farbe | Farben",
    "company": "Firma",
    "companyName": "Name der Firma",
    "confirm": "Bestätigen",
    "confirmation": "Bestätigung",
    "warning": "Warnung",
    "codeIsRequired": "Bestätigungscode erforderlich",
    "code": "Code",
    "contact": "Kontakt",
    "country": "Land",
    "create": "Erstellen",
    "checkThePlayer": "Mit dem Internet verbinden. An die Stromversorgung anschließen.",
    "checkDetails": "Details prüfen",
    "chooseHorizontalOrVerticalScreenOrientations": "Wählen Sie die Bildschirmausrichtung",
    "continue": "Fortsetzen",
    "conctactSystemAdmin": "Bitte wenden Sie sich an Ihren Systemadministrator.",
    "custom": "neu",
    "customerInfo": "Kundeninformationen",
    "date": "Datum",
    "deactivate": "deaktivieren",
    "default": "Standard",
    "dropFilesHere": "Dateien hier verschieben.",
    "delete": "löschen",
    "deleteAccount": "Konto löschen",
    "deleteAccountWithMultipleUsersMessage": "Sie müssen alle anderen Benutzer entfernen, bevor Sie dieses Konto löschen können.",
    "deleteAccountWithDistributorRightsMessage": "Dieses Konto kann nicht gelöscht werden. Es gehört einem Händler.",
    "deleteAccountTitleThisActionWill": "Durch diese Aktion wird",
    "deleteAccountImplications": {
      "deleteAccount": "1. Konto gelöscht",
      "deleteUser": "2. Benutzer gelöscht"
    },
    "youCannotDeleteUserAsOnlyUserInAccount": "Sie können den Benutzer nicht löschen, da Sie der einzige Benutzer des Kontos sind.",
    "deleteUser": "Benutzer löschen",
    "deleteOnAllPlayers": "Auf ALLEN PLAYERN LÖSCHEN.",
    "deleteFromSchedule": "Aus Zeitplan löschen",
    "demoVersion": "Demo-Version",
    "disable": "deaktivieren",
    "disabled": "deaktiviert",
    "distributor": "Händler",
    "downgradeAccount": "Downgrade-Konto",
    "downgradeTo": "Downgrade auf {plan}",
    "duplicate": "Duplizieren",
    "duplicateFile": "Datei duplizieren",
    "duplicateInSchedule": "In Zeitplan duplizieren",
    "duration": "Dauer",
    "adsDuration": "Werbedauer",
    "error": "Fehler",
    "email": "E-Mail",
    "emailAlreadyExists": "Die neue E-Mail-Adresse wird bereits von einem anderen Benutzer verwendet, bitte nutzen Sie eine andere.",
    "enable": "aktivieren",
    "enabled": "aktiviert",
    "endDate": "Ende",
    "endTime": "Ende",
    "end": "beenden",
    "edit": "Bearbeiten",
    "editProject": "Projekt bearbeiten",
    "feedbackForm": "Feedback geben",
    "firstName": "Vorname",
    "firmwareUpdate": "FIRMWARE-AKTUALISIERUNG",
    "failed": "Support kontaktieren",
    "file": "Datei | Dateien",
    "forgotPassword": "Passwort vergessen",
    "formatNotSupported": "'{format}' Dateien werden nicht unterstützt.",
    "firmware": "Firmware",
    "freeVersion": "Kostenlose Version",
    "freeVersionNA": "Kostenlose Version nicht verfügbar",
    "get": "erhalten",
    "getCode": "Code erhalten",
    "getConfig": "Konfiguration erhalten",
    "generateNewAPIKey": "Neuen API-Schlüssel generieren",
    "generateUserAPIKeyWarningMessage": "Durch diese Aktion wird der vorherige API-Schlüssel ungültig; jede bestehende Verbindung zur API muss neu konfiguriert werden, damit der neue API-Schlüssel verwendet werden kann.",
    "goBack": "Zurück gehen",
    "goToLogin": "Zum Login",
    "helpCenter": "Hilfezentrum",
    "horizontalView": "Horizontale Ansicht",
    "image": "Bild | Bilder",
    "implications": "Implikationen",
    "implicationsDeleteTag": "Diese Aktion löscht dieses Tag aus allen {deleteFrom}. Dies kann sich auf Ihre Benutzerberechtigungen und Ihren Zeitplan auswirken.",
    "implicationsDeleteLedTag": "Durch diese Aktion wird dieses Tag von allen Playern gelöscht. Jeder Player, der dieses Tag hatte, muss neu konfiguriert werden, damit Inhalte mit dieser Auflösung wieder veröffentlicht werden können.",
    "implicationsDeletePopId": "Diese Aktion löscht diese PoP-Kennung überall dort, wo sie verwendet wird.",
    "importantToNote": "Bitte unbedingt beachten",
    "logo": "Logo",
    "userProfile": "Benutzerprofil",
    "userSignOut": "Ausloggen",
    "userNotConfirmed": "Benutzer nicht bestätigt",
    "userNotFound": "Benutzer existiert nicht. Bitte stellen Sie sicher, dass dieses Konto existiert",
    "userManagement": "Benutzer Management",
    "id": "ID",
    "incorrectUsername": "Falsche E-Mail",
    "incorrectPassword": "Falsches Passwort",
    "installed": "Installiert",
    "installedOrCapacity": "Installiert / Kapazität",
    "installedOrCapacityUnlimitedMaxValue": "von Unbegrenzten Playern",
    "invalidEmail": "Ungültige E-Mail",
    "invalidPassword": "Ungültiges Passwort",
    "invalidUserdata": "Support kontaktieren",
    "invalidSerialNumber": "Seriennummer falsch",
    "invalidDSOSTypeAmount": "Ungültiger Wert. Bitte geben Sie eine Zahl ein.",
    "invalidResolution": "Ungültige Auflösung",
    "invoice": "Rechnung | Rechnungen",
    "inviteUser": "Benutzer einladen",
    "keyboardShortcuts": "Tastenkombinationen",
    "requiredDeviceName": "Name erforderlich",
    "regular": "regulär",
    "resetPassword": "Passwort zurücksetzen",
    "loading": "Wird geladen...",
    "lastName": "Nachname",
    "lastLogin": "Letzte Anmeldung",
    "modify": "ändern",
    "monitoring": "Überwachung",
    "newPassword": "Neues Passwort",
    "newPasswordRequiredWarning": "Sie müssen Ihr Passwort ändern, bevor Sie fortfahren können",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "new": "Neu",
    "newCanvas": "Neue Arbeitsfläche",
    "newProject": "neues Projekt",
    "newEmail": "Neue E-Mail",
    "newResolution": "Neue Auflösung",
    "name": "Name",
    "naText": "Nicht vorhanden",
    "next": "Weiter",
    "nextRenewalDate": "Nächste Verlängerung am {renewalDate}",
    "noVideoAvailable": "Kein Video verfügbar.",
    "noEmailProvided": "Keine E-Mail angegeben",
    "none": "keine",
    "noSearchResults": "keine Ergebnisse",
    "noPermissionToAccessThePage": "Zugang verweigert",
    "noPlayersInstalled": "Keine Player installiert",
    "noPlayerGroupsAvailable": "Keine Playergruppen vorhanden",
    "notConfigured": "Einrichtung erforderlich",
    "nameYourPlayerEGReception": "Benennen Sie Ihren Player, z.B. Rezeption",
    "ok": "OK",
    "or": "oder",
    "order": "Bestellung | Bestellungen",
    "orders": "Bestellungen",
    "offline": "Offline",
    "online": "online",
    "options": "Optionen",
    "page": "Seite",
    "player": "Player",
    "playerName": "Player-Name",
    "playerModel": "Player-Modell",
    "playerGroups": "Player-Gruppen",
    "pleaseEnterACity": "Stadt eingeben",
    "pin": "PIN",
    "pinShownOnYourScreen": "PIN auf Ihrem Bildschirm",
    "playTime": "Spielzeit",
    "PleaseTryAgainOrHeadBackToTheHomepage": "Bitte versuchen Sie es erneut oder gehen Sie zurück zur Homepage.",
    "playerIsNotConnectedToTheCloud": "Seriennummer nicht korrekt",
    "pleaseTryAgain": "Versuchen Sie es nochmal.",
    "pleaseEnterThePin": "PIN erforderlich",
    "pleaseEnterValidPin": "Geben Sie die 4- oder 6-stellige Nummer ein, die auf Ihrem Bildschirm angezeigt wird",
    "pinMustBeFourDigitNumber": "Die PIN muss eine 4- bis 6-stellige Zahl sein",
    "pinMustBeAtleastOneThousand": "Die PIN muss mindestens 1000 sein",
    "pleaseCheckYourEmailForVerificationCode": "Bestätigungscode wurde an Ihre E-Mail-Adresse versendet",
    "password": "Passwort",
    "passwordDidNotMatch": "Passwort stimmt nicht überein",
    "passwordCannotBeReset": "Passwort kann nicht zurückgesetzt werden",
    "passwordHasBeenChanged": "Ihr Passwort wurde geändert",
    "passwordAttemptLimitExceeded": "Anzahl der Versuche überschritten, bitte versuchen Sie es nach einiger Zeit erneut.",
    "passwordPolicyRequirementText": "Das Passwort muss mindestens 8 Zeichen lang sein und Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.",
    "price": "Preis",
    "priceSlashMonth": "Preis / Monat",
    "priority": "Priorität",
    "project": "Projekt | Projekte",
    "projectName": "Projektname",
    "profile": "Profil",
    "proofOfPlay": "Proof of Play",
    "preview": "Vorschau",
    "previewUnavailable": "Vorschau nicht verfügbar",
    "privacy": "Datenschutz",
    "proceed": "Weiter",
    "publishTo": "Veröffentlichen in",
    "releaseNotes": "Versionshinweise",
    "remove": "entfernen",
    "removeUserFromAccount": "Benutzer aus Konto entfernen",
    "replace": "ersetzen",
    "reporting": "Berichterstattung",
    "reset": "zurücksetzen",
    "restart": "Neustart",
    "resolution": "Auflösung",
    "reactivate": "reaktivieren",
    "resetPasswordDescription": "Geben Sie eine E-Mail-Adresse ein, um den Bestätigungscode zu erhalten",
    "resetPasswordCodeSent": "Bestätigungscode wurde an Ihre E-Mail versendet",
    "resetPasswordCodeSentIfAccountExist": "WENN KONTO VORHANDEN IST",
    "requiredAccountName": "Kontoname erforderlich",
    "requiredEmail": "E-Mail erforderlich",
    "requiredCountry": "Land erforderlich",
    "requiredPassword": "Passwort erforderlich",
    "requiredConfirmPassword": "Passwortbestätigung erforderlich",
    "requiredFirstName": "Vorname erforderlich",
    "requiredLastName": "Nachname erforderlich",
    "requiredName": "Name erforderlich",
    "requiredUsername": "E-Mail erforderlich",
    "requiredVerificationCode": "Bestätigungscode erforderlich",
    "requiredSerialNumber": "Seriennummer erforderlich",
    "requiredCity": "Stadt erforderlich",
    "requiredState": "Land erforderlich",
    "requiredZipOrPostalCode": "Postleitzahl erforderlich",
    "requiredStreetAndNumber": "Straße und Hausnummer erforderlich",
    "requiredCompanyName": "Firmenname erforderlich",
    "requiredDataStorageRegion": "Datenregion erforderlich",
    "invalidDataStorageRegion": "Ungültige Datenregion",
    "review": "überprüfen",
    "searching": "Suche läuft",
    "search": "Suche",
    "addressSearchPlaceholder": "Geben Sie die Adresse ein, um Players zu finden",
    "signOut": "ausloggen",
    "status": "Status",
    "save": "speichern",
    "reconfigure": "Einrichtung neu starten",
    "saveAs": "Speichern als",
    "saveChanges": "Änderungen speichern",
    "savedStyles": "Gespeicherte Stile",
    "schedule": "Planen",
    "scheduledToTag": "Tag Geplant",
    "screen": "Bildschirm",
    "screenOn": "Bildschirm ein",
    "screenOrientation": "Bildschirmausrichtung",
    "security": "Sicherheit",
    "sendCode": "Code senden",
    "sendEmail": "Senden",
    "sendInvitation": "Einladung senden",
    "sendTo": "Senden an",
    "serial": "Seriennummer",
    "serialNumber": "Seriennummer",
    "serialNumberAlreadyAssigned": "Seriennummer bereits vergeben",
    "select": "AUSWÄHLEN",
    "selectAll": "Alle auswählen",
    "selectLanguage": "Sprache wählen",
    "setup": "Einrichtung",
    "support": "Unterstützung",
    "settings": "Einstellungen",
    "shapeColors": "Formfarben",
    "shareWithText": "{productShortName} Digital Signage. Einfach. Clever. Effektiv.",
    "signIn": "Einloggen",
    "signUp": "Registrieren",
    "signUpErrorMessageAccountEmailExist": "Ein Konto mit der angegebenen E-Mail existiert bereits.",
    "slowSync": "LANGSAME SYNCHRONISATION",
    "sorry": "Es tut uns Leid.",
    "streetAndNumber": "Straße und Nummer",
    "success": "Erfolg",
    "summary": "Zusammenfassung",
    "somethingWentWrong": "Etwas ist schief gelaufen",
    "song": "Lied | Lieder",
    "startDate": "Anfangsdatum",
    "startTime": "Start",
    "start": "Start",
    "state": "Staat",
    "steps": "Schritte",
    "styleName": "Name des Stils",
    "storage": "Speicher",
    "subtotal": "Zwischensumme",
    "subscription": "Abonnement",
    "subscriptionMonthlyAutoRenew": "Monatlich (automatische Verlängerung)",
    "ssoLoginErrorTitle": "Ein Fehler ist aufgetreten. Anmeldung ist derzeit nicht möglich. Bitte versuchen Sie es später erneut oder wenden Sie sich an Ihren Administrator.",
    "ssoMigrateAccountStep1Title1": "Ein Konto für {email} existiert bereits.",
    "ssoMigrateAccountStep1Title2": "Sie können es ändern, um {provider} SSO zu verwenden.",
    "ssoMigrateAccountStep1Title3": "Fahren Sie fort, um den Wechsel zu bestätigen.",
    "ssoMigrateAccountStep2Title1": "Sobald Sie den Wechsel zu {provider} SSO bestätigt haben,",
    "ssoMigrateAccountStep2Title2": "werden Ihre vorherigen Anmeldedaten nicht mehr funktionieren.",
    "ssoMigrateAccountStep2Title3": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "ssoMigrateAccountVerifyTitle1": "Wir müssen Ihr bestehendes {email}-Konto verifizieren.",
    "ssoMigrateAccountVerifyTitle2": "Bitte melden Sie sich mit diesem Konto an, um fortzufahren.",
    "tag": "Tag | Tags",
    "defaultTags": "Standard-Tags",
    "text": "Text",
    "timeZone": "Zeitzone",
    "time": "Zeit",
    "timeShorthandSecond": "SEK",
    "timeShorthandMinute": "MIN",
    "timeShorthandHour": "STD",
    "template": "Vorlage | Vorlagen",
    "temporaryPassword": "Temporäres Passwort",
    "tempPasswordExpiredPleaseContactAdmin": "Das temporäre Passwort ist abgelaufen. Bitte wenden Sie sich an Ihren Admin.",
    "total": "gesamt",
    "tutorial": "Tutorial | Tutorials",
    "user": "Nutzer",
    "userAPIKey": "API-Schlüssel",
    "userNotActive": "Benutzer nicht aktiv",
    "usernameShouldBeValidEmail": "Benutzername sollte eine gültige E-Mail sein",
    "updatedAccountInfo": "Ihre Kontoinformationen wurden aktualisiert.",
    "updatedCustomerInfo": "Ihre Kundeninformationen wurden aktualisiert.",
    "updatedProfile": "Ihr Benutzerprofil wurde aktualisiert.",
    "updated": "aktualisiert",
    "upload": "Hochladen",
    "upgrade": "upgraden",
    "upTime": "Betriebszeit",
    "video": "Video",
    "vat": "MwSt.",
    "verificationCode": "Verifizierungsschlüssel",
    "verticalView": "Vertikale Ansicht",
    "withResolution": "mit {resolution} Auflösung",
    "yourPlan": "Ihr Plan",
    "youHaveLeftAccount": "Sie haben Ihr Konto verlassen",
    "zipOrPostalCode": "Postleitzahl",
    "mon": "Mo",
    "tue": "Di",
    "wed": "Mi",
    "thu": "Do",
    "fri": "Fr.",
    "sat": "Sa",
    "sun": "So",
    "apps": "Anwendungen",
    "multiplePopIdsNotAllowed": "Jede Datei darf nur eine Proof-of-Play-Kennung haben.",
    "forbidden": "Etwas ist schief gelaufen, und wir konnten Ihre Anfrage nicht zu Ende bearbeiten. Sie werden in Kürze zur Startseite weitergeleitet.",
    "dataStorageRegion": "Datenregion",
    "verificationSentToEmailIfExist": "Bestätigungscode wurde an Ihre E-Mail gesendet (falls Konto existiert)",
    "alreadyHaveAnAccountRedirect": "Haben Sie bereits ein Konto? {linkStart}Anmelden{linkEnd}",
    "emailText": "E-Mail",
    "passwordText": "Passwort",
    "signupWith": "Registrieren mit",
    "setNewPassword": "Passwort festlegen",
    "passwordHint": "{minStart}Mindestens 8 Zeichen,{minEnd} {upStart}Großbuchstabe,{upEnd} {lowStart}Kleinbuchstabe,{lowEnd} {numStart}Zahl{numEnd}{numSpecialSeparatorStart} & {numSpecialSeparatorEnd}{spStart}Sonderzeichen{spEnd}.",
    "home": "Startseite",
    "loginWithName": "Mit {name} anmelden",
    "signupWithName": "Mit {name} registrieren",
    "fileType": "Dateityp",
    "lastModified": "Zuletzt geändert",
    "images": "Bilder",
    "videos": "Videos",
    "projectsOrPdf": "Projekte / PDF",
    "elementiProject": "Elementi-Projekte",
    "scheduled": "Geplant",
    "notScheduled": "Nicht geplant",
    "from": "Von",
    "to": "Bis",
    "fileTypes": "Dateitypen",
    "contentStatus": "Inhaltsstatus",
    "modifiedDate": "Änderungsdatum",
    "filters": "Filter",
    "sortBy": "Sortieren nach",
    "sort": "Sortieren",
    "lastModifiedDesc": "Zuletzt geändert (Neueste zuerst)",
    "lastModifiedAsc": "Zuletzt geändert (Älteste zuerst)",
    "nameAsc": "Name (A → Z)",
    "nameDesc": "Name (Z → A)",
    "grid": "Raster",
    "canvas": "Leinwand",
    "audioPlaylist": "Audio-Wiedergabeliste",
    "isAlertActive": "Alert aktiv",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "filesPage": "Dateien-Seite",
    "ledPage": "LED-Seite",
    "videowallPage": "Videowall-Seite",
    "alertPage": "Benachrichtigungsseite"
  },
  "buttons": {
    "backToProduct": "Zurück zu {productName}",
    "reload": "Neu laden",
    "previous": "Vorherige",
    "next": "Weiter",
    "loadMore": "Mehr laden",
    "addNewUser": "Neuen Benutzer hinzufügen",
    "apply": "Anwenden",
    "clearAll": "Alle löschen",
    "reset": "Zurücksetzen",
    "tryItNow": "Jetzt ausprobieren",
    "switchBack": "Zurückwechseln",
    "cancel": "Abbrechen",
    "deleteMedia": "Medien löschen",
    "deletePlayer": "Player löschen",
    "deleteTag": "Tag löschen",
    "deletePopId": "PoP-ID löschen",
    "deleteUser": "Benutzer löschen",
    "continueWithoutSaving": "Ohne Speichern fortfahren",
    "close": "Schließen",
    "cancelOrder": "Bestellung stornieren",
    "removeUser": "Benutzer entfernen",
    "deleteTemplate": "Vorlage löschen",
    "deleteStyle": "Stil löschen",
    "ok": "OK",
    "delete": "Löschen",
    "keepBoth": "Beide behalten",
    "replaceExistingFile": "Vorhandene Datei ersetzen",
    "replaceExistingFiles": "Vorhandene Dateien ersetzen"
  },
  "texts": {
    "youAreLoggingIn": "Sie melden sich an mit",
    "productAccessDisabled": "Sie haben keinen Zugriff auf {product}",
    "productAccessDisabledWarning": "Sie haben keinen Zugriff auf {product} für das Konto {account}.\n\nEntweder wurde Ihnen der Zugriff auf dieses Produkt nicht gewährt, oder Ihr Zugriff wurde vom Global Admin widerrufen. Bitte wenden Sie sich an den Global Admin, um weitere Informationen zu erhalten oder um Zugriff anzufordern.\n\nSie können weiterhin auf andere Produkte zugreifen, die Sie in diesem Konto verwenden dürfen.",
    "tablePageCountWTotal": "Zeige {min}{separator}{max} von {total}",
    "tablePageCountWoutTotal": "Zeige {min}{separator}{max}",
    "dataStorageRegionHint": "Wählen Sie die Region aus, in der Ihre Kontodaten gespeichert werden sollen. Diese Entscheidung sollte mit Ihren lokalen Datenschutzgesetzen und Compliance-Anforderungen übereinstimmen. Bitte beachten Sie: Nach der Auswahl kann die Datenresidenz-Region später nicht mehr geändert werden.",
    "welcomeToHUB": "Willkommen im SpinetiX HUB!",
    "welcomeToHUBDesc": "SpinetiX HUB ist Ihre All-in-One-Online-Plattform zur Verwaltung aller Aspekte Ihrer SpinetiX Digital Signage in der Cloud.",
    "hubGlobalAdmin": "SpinetiX Global Admin",
    "hubGlobalAdminDesc": "Dieser Benutzer ist ein Global Admin im HUB, was ihm automatisch die Admin-Rolle in ARYA gewährt. Diese Rollenzuweisung kann nicht geändert werden.",
    "removeAccessFromAryaTitle": "Zugriff auf ARYA entfernen?",
    "removeAccessFromAryaMessage": "Dies entfernt nur den Zugriff von {userName} auf ARYA.",
    "removeAccessFromAryaByNonGlobalAdmin": "Um den Benutzer aus dem HUB-Konto zu entfernen, wenden Sie sich bitte an Ihren Global Admin.",
    "removeAccessFromAryaByGlobalAdmin": "Sie werden weiterhin Zugriff auf andere Produkte in diesem HUB-Konto haben.\n\nUm den Benutzer aus dem HUB-Konto zu entfernen, gehen Sie bitte zu {link}",
    "hubUserManagement": "HUB-Benutzerverwaltung",
    "goToHUBUserManagement": "gehen Sie bitte zur HUB-Benutzerverwaltung.",
    "noContentHasBeenScheduledYet": "Es wurde noch kein Inhalt geplant.",
    "emptyFilterTablePlaceholder": "Wir konnten keine Elemente finden, die Ihrer Suche entsprechen. Versuchen Sie, Ihre Suchbegriffe anzupassen und erneut zu suchen!",
    "requestId": "Anfrage-ID:",
    "externalSignInMessage": "Sie sind mit einem externen Identitätsanbieter angemeldet (z. B. Google, Facebook oder SSO mit einem anderen Identitätsanbieter). Ihre Anmeldeinformationen, einschließlich {email} und {password}, werden von diesem Anbieter verwaltet.",
    "youHaveUnsavedChanges": "Sie haben nicht gespeicherte Änderungen.",
    "waitForUploadingFile": "Datei wird hochgeladen, bitte warten...",
    "defaultTagsNote": "Projekte übernehmen die Tags des Style-Packs, wenn sie aus der Vorlage erstellt werden. Wenn Sie später Tags zum Style-Pack hinzufügen oder entfernen, werden bestehende Projekte nicht aktualisiert.",
    "seeAll": "Alle anzeigen",
    "allPlayTimes": "Alle Wiedergabezeiten"
  },
  "unsupportedBrowser": {
    "bannerTitle": "Ihr Browser wird nicht unterstützt",
    "bannerMessage": "Sie verwenden einen nicht unterstützten Browser. Einige Features funktionieren ggf. nicht ordnungsgemäß. Um unser Produkt optimal nutzen zu können, wechseln Sie bitte zu {highlightStart}Google Chrome{highlightEnd} oder {highlightStart}Microsoft Edge{highlightEnd}."
  },
  "switchedAccount": {
    "title": "Konto gewechselt",
    "desc1": "Willkommen zurück.",
    "switch": "wechseln",
    "text1": "Konto gewechselt",
    "text2": "zu {account}"
  },
  "plans": {
    "downgradedToFreeDesc": "{plan} ist jetzt aktiviert. Ihre Kreditkarte wird am Ende des Abrechnungszeitraums ein letztes Mal belastet.",
    "free": "Gratis",
    "tags": "SMART SYNC & TAGS",
    "sharedStorage": "Geteilter Speicher",
    "custom": "Benutzerdefinierte Einstellungen und Warnungen",
    "playerStorage": "Player-Speicher",
    "playerPerMonth": "Player / Monat",
    "review": {
      "termsAndConditionsMain": "Mit Ihrer Bestellung akzeptieren Sie die",
      "termsAndConditionsSub": "SpinetiX Verkaufsbedingungen"
    }
  },
  "filters": {
    "images": "Bilder",
    "videos": "Videos",
    "audio": "Audio",
    "projectsOrPdf": "Projekte / PDF",
    "scheduled": "geplant",
    "elementiProject": "Elementi-Projekte"
  },
  "template": {
    "24H": "24 Std.",
    "AM/PM": "AM/PM",
    "addPage": "Seite hinzufügen",
    "arrowSettings": "Pfeil-Einstellungen",
    "back": "Zurück",
    "background": "Hintergrund",
    "both": "Beide",
    "bottom": "unten",
    "center": "Mitte",
    "cellSettings": "Zellen-Einstellungen",
    "clock": "Uhr",
    "countdown": "Countdown",
    "clockSettings": "Uhr-Einstellungen",
    "countdownSettings": "Countdown-Einstellungen",
    "custom": "neu",
    "changeMedia": "Medien ändern",
    "default": "Standard",
    "duplicatePage": "Doppelte seite",
    "date": "Datum",
    "days": "Tage",
    "effects": "Effekte",
    "fade": "Verdunkeln",
    "fill": "füllen",
    "front": "Vorderseite",
    "frameFitting": "Rahmenmontage",
    "hours": "Stunden",
    "imageEffects": "Bild-Effekte",
    "kenBurns": "Ken Burns",
    "noEffect": "Kein Effekt",
    "noBorder": "Kein Rand",
    "noMargin": "Keine Beschnittzugabe",
    "L": "L",
    "large": "groß",
    "left": "Links",
    "local": "lokal",
    "long": "lang",
    "M": "M",
    "meet": "treffen",
    "media": "Medien",
    "menu": "Menü",
    "mediatable": "Medientabelle",
    "middle": "Mitte",
    "month": "Monat",
    "overlay": "Overlay",
    "overview": "Übersicht",
    "playOnce": "Einmal abspielen",
    "qr": "qr",
    "reg": "reg",
    "repeat": "wiederholen",
    "right": "Rechts",
    "rss": "RSS",
    "shape": "Form",
    "shapeSettings": "Formeinstellungen",
    "shapeSettingsHint": "Tipp: Tippen Sie etwas ein, um Text hinzuzufügen.",
    "slice": "Teil",
    "slide": "Folie",
    "small": "klein",
    "smart": "smart",
    "S": "S",
    "time": "Zeit",
    "timeAndDate": "ZEIT + DATUM",
    "tableSettings": "Tabelleneinstellungen",
    "text": "Text",
    "textSettings": "Texteinstellungen",
    "top": "oben",
    "wayfinding": "Orientierung",
    "weather": "Wetter",
    "html": "Website",
    "url": "URL",
    "videoin": "Video-Eingang",
    "videoWidth": "Videobreite",
    "videoHeight": "Videohöhe",
    "videoSettings": "Videoeinstellungen",
    "frameRate": "Bildrate",
    "frameWidth": "Breite wählen",
    "format": "Format",
    "error": {
      "invalidLink": "Link ungültig"
    },
    "placeholder": {
      "url": "URL eingeben"
    },
    "weatherIconSettings": "Wettersymbol-Einstellungen",
    "weatherLocationSettings": "Wetterstandort-Einstellungen",
    "weatherLocationSettingsHint": "Tipp: Geben Sie den Namen des Ortes ein",
    "webpageSettings": "Webseiten-Einstellungen",
    "qrSettings": "QR-Einstellungen",
    "rssSettings": "RSS-Einstellungen",
    "rssSettingsTooltip": "Die von {productName} angebotenen RSS-Feeds werden von <b>Drittanbietern</b> bezogen.<br>Wir bemühen uns, eine vielfältige Auswahl an Feeds anzubieten, um Ihren Bedürfnissen gerecht zu werden; ihre Qualität und Leistung sind jedoch ausschließlich von den Drittanbietern abhängig.",
    "stream": "Stream",
    "list": "Liste"
  },
  "templates": {
    "duration": "Dauer",
    "pageDuration": "Seitendauer",
    "timezone": "Zeitzone",
    "tags": "Tags",
    "playtimes": "Spielzeit",
    "alignElements": "Elemente ausrichten",
    "removeTemplateConfirmation": "Möchten Sie diese Vorlage wirklich aus dem Stil \"{styleName}\" löschen?",
    "deleteStyleConfirmation": "Möchten Sie den Stil \"{styleName}\" wirklich löschen?",
    "deleteStyleWarning": "Durch das Löschen dieses Stils werden alle darin erstellten Vorlagen entfernt.",
    "noTemplatesAvailable": "Keine Vorlagen verfügbar",
    "noStylePackAccess": "Sie haben derzeit keinen Zugriff auf Style-Packs mit Vorlagen. Style-Packs sind nur verfügbar, wenn sie über Ihre zugewiesenen Berechtigungen oder Tags mit Ihnen geteilt wurden.\nWenn Sie der Meinung sind, dass Sie Zugriff haben sollten, wenden Sie sich bitte an Ihren Kontoadministrator."
  },
  "Hours": {
    "title": "Titel",
    "time": "Std",
    "media": "Medien"
  },
  "Info": {
    "info": "Info",
    "title": "Titel",
    "description": "Text",
    "media": "Medien"
  },
  "Logo": {
    "title": "Text"
  },
  "Menu": {
    "menu": "Menü",
    "title": "Text",
    "price": "Preis",
    "media": "Medien"
  },
  "News": {
    "news": "Nachrichten",
    "title": "Text",
    "timezone": "Zeitzone",
    "format": "Format",
    "media": "Medien"
  },
  "Person": {
    "person": "Person",
    "title": "Text oben",
    "description": "Text unten",
    "media": "Medien"
  },
  "Product": {
    "product": "Produkt",
    "title": "Text",
    "price": "Preis",
    "media": "Medien"
  },
  "RSS": {
    "rss-news": "RSS-Nachrichten",
    "rss": "RSS",
    "news": "Nachrichten"
  },
  "Weather": {
    "weather": "Wetter",
    "locations": "Stadt",
    "display": "Anzeigen",
    "media": "Medien"
  },
  "playerSetup": {
    "navConfirm": "Bestätigen",
    "navFinish": "Abschliessen",
    "navNext": "Weiter",
    "navPrev": "Zurück",
    "navCancel": "Abbrechen",
    "addPlayerToPlan": "Player zu Ihrem Plan hinzufügen",
    "currentPlan": "Aktueller Plan",
    "canvasName": "Name der Arbeitsfläche",
    "canvasVideoNote": "Sie finden Ihre neue Arbeitsfläche im {canvasType} unter diesem Namen.",
    "canvasVideoNoteType_led": "LED-Bereich",
    "canvasVideoNoteType_videowall": "Video-Wandabschnitt",
    "canvasSize": "Größe der Arbeitsfläche",
    "canvasSizeFormatted": "{canvasSize} Pixel",
    "updateTo": "Aktualisieren auf",
    "numberOfPlayers": "Anzahl der Player",
    "dialogTitle": "Playereinrichtung",
    "onlyDigitsRequired": "Bitte nur Ziffern eingeben",
    "serialNumberRequired": "Seriennummer darf nicht leer sein",
    "incorrectSerialNumber": "Bitte die korrekte Seriennummer eingeben",
    "incorrectSerialNumberCharacters": "Bitte eine gültige Abgabe machen. In diesem Feld können nur englische Buchstaben und Zahlen verwendet werden.",
    "incorrectInput": "Falsche Eingabe",
    "playerName": "Name",
    "playerNamePlaceholder": "Playername",
    "requiredPlayerName": "Playername ist erforderlich",
    "requiredScreenDiagonal": "Bildschirmdiagonale ist erforderlich",
    "requiredHorizontalBezel": "Horizontale(r) Umrandung/Abstand ist erforderlich",
    "requiredVerticalBezel": "Vertikale(r) Umrandung/Abstand ist erforderlich",
    "playerTimezoneHint": "Wählen Sie die Zeitzone des Players aus",
    "Progress_PIN": "PIN",
    "Progress_Name": "Name & Zeitzone",
    "Progress_DisplaySettings": "Anzeigeeinstellungen",
    "Progress_Application": "Anwendung",
    "Progress_Arrangement": "Anordnung",
    "Progress_Adjustments": "Anpassungen",
    "DisplayOrientation": "Anzeigeausrichtung",
    "DisplayResolution": "Anzeigeauflösung",
    "DisplayResolutionHint": "Wählen Sie die Anzeigeauflösung aus",
    "Application": "Anwendung",
    "ApplicationSingleDisplay": "Einzelanzeige",
    "ApplicationMirroring": "Spiegelung",
    "ApplicationVideowall": "Videowand",
    "ApplicationAvailable": "* Erhältlich mit",
    "ApplicationAvailbleWithNote": "*Erhältlich mit",
    "screenDiagonal": "Bildschirmdiagonale",
    "SelectApplication": "Die Anwendung auswählen",
    "SelectDisplayOrientation": "Anzeigeausrichtung auswählen",
    "SelectNumberOfDisplays": "Wählen Sie die Anzahl der Anzeigen",
    "standardScreenOnly": "Nur Standard-Bildschirm (9:16 & 16:9)",
    "OrientationAndResolution": "Die Ausrichtungs- und Auflösungseinstellungen gelten für alle Anzeigen",
    "DisplaysArrangement": "Anzeigeanordnung",
    "SelectDisplayArrangement": "Anzeigeanordnung auswählen",
    "HorizontalBezel": "Horizontale Umrandung/Lücke",
    "VerticalBezel": "Vertikale Umrandung/Lücke",
    "OutputResolutions": "Ausgabeauflösungen",
    "CannotCreateLEDTag": "Kann keine LED-Auflösung erstellen",
    "CannotCreateVideowallTag": "Kann keine Videowand-Leinwand erstellen",
    "UnknownError": "Unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    "InvalidAdjustmentsForm": "Es gibt Eingabevalidierungsfehler, bitte füllen Sie alle Felder korrekt aus",
    "CanvasDimensionsError": "Leinwandbreite oder -höhe werden nicht richtig generiert",
    "playerDeleteConfirmation": "Möchten Sie den Player {playerName} wirklich löschen?",
    "playerDeleteWarning": "Durch das Löschen des Players wird er aus Ihrem SpinetiX HUB-Konto entfernt und alle zugehörigen Einstellungen, einschließlich der Planung, werden gelöscht."
  },
  "planCard": {
    "getPremium": "Premium auswählen",
    "bestforGettingStarted": "Die beste Option für Einsteiger",
    "discovery": "Discovery",
    "free": "Kostenlos",
    "oneUser": "1 Benutzer",
    "oneGBStorage": "1 GB Speicherplatz",
    "nineTemplates": "9 Vorlagen",
    "yourPlan": "Ihr Plan",
    "elevateYourDigitalSignage": "Heben Sie Ihr Digital-Signage-Projekt auf ein neues Niveau",
    "premium": "Premium",
    "premiumPlanPrice": "21 CHF",
    "playerPerMonth": "Player / Monat",
    "tenUsersAndRoles": "10 Benutzer und Benutzerrollen",
    "tenGBPlayerStorage": "10 GB / Player-Speicher",
    "twelveTemplatesCustomizable": "12 Vorlagen / anpassbar",
    "twelveApps": "12 Anwendungen einschließlich Webseite",
    "elevenApps": "11 Anwendungen",
    "assetGrouping": "Gruppierung von Assets",
    "scheduleAutomation": "Zeitplan für die Automatisierung",
    "priorityScheduling": "Vorrangige Terminplanung",
    "alerts": "Warnungen",
    "audio": "Audio",
    "videoWallSupport": "Videowand-Unterstützung**",
    "new": "Neu!",
    "withTheNew": "*mit dem neuen"
  },
  "planUpgrade": {
    "errorFetchingInvoice": "Fehler beim Abrufen der Rechnung. Bitte versuchen Sie es erneut.",
    "close": "schließen",
    "getPremium": "Premium auswählen!",
    "companyName": "Name der Firma",
    "dialogTitle": "Plan-Upgrade",
    "navConfirm": "Bestätigen",
    "navFinish": "ENDE",
    "navNext": "Weiter",
    "navPrev": "Zurück",
    "navCancel": "Abbrechen",
    "VATNumber": "MwSt-Nummer",
    "Overview": "Übersicht",
    "AccountOwner": "Kontoinhaber",
    "CompanyInfo": "Infos zur Firma",
    "BillingDetails": "Rechnungsdetails",
    "Payment": "Zahlung",
    "tryAgain": "NOCH EINMAL VERSUCHEN",
    "paymentSuccessful": "Zahlung erfolgreich",
    "welcomeToPremium": "Willkommen bei Premium!",
    "paymentFailed": "Die Zahlung ist fehlgeschlagen.",
    "selectCountry": "Land auswählen",
    "selectState": "Staat auswählen"
  },
  "licenseOrdering": {
    "yourOrders": "Ihre Bestellungen",
    "cancelOrder": "BESTELLUNG STORNIEREN",
    "orderNumber": "Bestellnummer",
    "orderDate": "Datum der Bestellung",
    "comment1": "Kommentar 1",
    "comment2": "Kommentar 2",
    "close": "SCHLIESSEN",
    "cancelOrderWarning": "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
    "noOrdersAvailable": "Sie haben keine Bestellungen aufgegeben",
    "noRecordsFound": "Keine Ergebnisse für die Suche nach \"{query}\" gefunden",
    "noRecordsFoundNote1": "Bitte überprüfen Sie Ihre Suche auf Tipp- oder andere Fehler",
    "noRecordsFoundNote2": "Versuchen Sie es mit einer anderen Suchanfrage"
  },
  "fileUpload": {
    "notAllowedToUploadMedia": "Der Benutzer ist nicht berechtigt, eine Aktualisierung der Medien vorzunehmen.",
    "hashMD5ComputationError": "Beim Berechnen des hashMD5 ist ein Fehler aufgetreten.",
    "duplicateFileUploadErrorTitle": "Eine Datei mit diesem Namen ist bereits vorhanden",
    "multipleDuplicateFileUploadErrorTitle": "Dateien mit diesen Namen sind bereits vorhanden",
    "duplicateFileUploadErrorDescription": "Eine Datei mit dem Namen \"{mediaName}\" ist bereits in Ihrer Bibliothek vorhanden.",
    "multipleDuplicateFileUploadErrorDescription": "Dateien mit den Namen \"{mediaNames}\" sind bereits in Ihrer Bibliothek vorhanden.",
    "duplicateFileUploadErrorMessage": "Überprüfen Sie die vorhandene(n) Datei(en) und wählen Sie aus, was Sie mit Ihrem neuen Upload tun möchten.\n{pleaseNote}: Wenn Sie die vorhandene Datei ersetzen, laden Sie die Seite nach Abschluss des Uploads neu, um die aktualisierte Version zu sehen.",
    "duplicateFileUploadPreviewTitle": "Vorhandene Datei(en)",
    "pleaseNote": "Bitte beachten"
  },
  "downloadLicense": {
    "confirmDownloadLicense": "Sind Sie sicher? Diese Methode ist ausschließlich für Player gedacht, die nicht mit dem Internet verbunden werden.",
    "confirmDownloadLicenseWarning": "Mit dieser Methode wird die Lizenz sofort mit der Seriennummer verknüpft, ohne Frist für Änderungen."
  },
  "activation": {
    "assign": "ZUWEISEN",
    "yourLicenses": "Ihre Lizenzen",
    "comment": "Kommentar",
    "playerSerialNumber": "Seriennummer des Players",
    "licenseCode": "Lizenz-Code",
    "activationDate": "Aktivierungsdatum",
    "license": "Lizenz",
    "suspend": "AUSSETZEN",
    "restore": "WIEDERHERSTELLEN",
    "download": "HERUNTERLADEN",
    "licenseAvailable": "Lizenz verfügbar",
    "licenseLockedToAPlayer": "Lizenz an einen Player gebunden",
    "playerSerialNumberRequired": "Player SerialNumber Code erforderlich",
    "licenseCodeRequired": "Lizenzcode erforderlich",
    "processing": "Verarbeitung",
    "waitingForPlayerToConnect": "Bitte warten, bis eine Verbindung zum Player aufgebaut wird",
    "noLicensesAvailable": "Sie haben keine Lizenzen hinzugefügt"
  },
  "resolutionCalculator": {
    "invalidPitch": "Ungültige Tonhöhe",
    "invalidSize": "Ungültige Größe"
  },
  "legal": {
    "legal": "Impressum",
    "endUserLicenseAgreement": "ENDBENUTZER-LIZENZVEREINBARUNG",
    "generalTermsAndConditionsOfSale": "ALLGEMEINE VERKAUFSBEDINGUNGEN",
    "termsOfService": "SERVICEBEDINGUNGEN",
    "privacyPolicy": "DATENSCHUTZPOLITIK",
    "cookieNotice": "COOKIE-HINWEIS",
    "downloadPDF": "PDF HERUNTERLADEN"
  },
  "accountSuspended": {
    "bannerTitle": "Ihr Abonnement ist abgelaufen!",
    "bannerMessage": "Wenn Sie sich eine Verlängerung wünschen, wenden Sie sich bitte an Ihren Wiederverkäufer."
  },
  "errors": {
    "invalid": {
      "verificationCode": "Der angegebene Bestätigungscode ist ungültig. Bitte versuchen Sie es erneut.",
      "passwordReset": "Das Passwort kann nicht zurückgesetzt werden.",
      "provider": "Ungültiger Anbieter. Bitte versuche es erneut.",
      "emailMismatch": "Die eingegebene E-Mail-Adresse stimmt nicht mit dem Konto überein, zu dem Sie migrieren möchten."
    },
    "existing": {
      "userAlreadyLinked": "Benutzer ist bereits mit einem anderen Identity Provider (IdP) verknüpft.",
      "accountInAnotherRegion": "Der Benutzer hat bereits ein Konto in einer anderen Region"
    },
    "failedRefreshToken": "Sie wurden abgemeldet. Bitte melden Sie sich erneut an, um fortzufahren.",
    "cannotMigrateAccountInAnotherRegion": "Die Migration zu SSO ist nicht möglich, da Ihre E-Mail-Adresse mit einer anderen Datenregion verknüpft ist als das Konto, zu dem Sie migrieren möchten.",
    "nonSSOAuthDenied": "Authentifizierung über einen Nicht-SSO-Anbieter ist nicht erlaubt.",
    "ssoMigrationFailed": "Zugriff verweigert: Du kannst nicht zu SSO wechseln, da dein Konto bereits mit einem anderen Identity Provider (IdP) verknüpft ist. Bitte wende dich für weitere Unterstützung an deinen Administrator.",
    "loginUnexpectedError": "Die Anmeldung ist aufgrund eines unerwarteten Fehlers fehlgeschlagen. Bitte versuche es erneut.",
    "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte laden Sie die Seite neu.",
    "somethingWentWrong": "Es sieht aus, als wäre etwas schiefgelaufen ({errorCode})",
    "somethingWentWrongDescription": "Beim Laden dieser Seite ist ein Fehler aufgetreten.<br><br><strong>Was Sie tun können:</strong><br>Aktualisieren Sie die Seite und versuchen Sie es erneut.<br>Wenn sie immer noch nicht lädt, wenden Sie sich bitte an den Support und teilen Sie die unten stehende Anfrage-ID mit.",
    "failedToUpdateAccountInfo": "Kontoinformationen konnten nicht aktualisiert werden.",
    "failedToFetchLicenses": "Lizenzen konnten nicht abgerufen werden.",
    "failedToDownloadLicense": "Lizenz konnte nicht heruntergeladen werden.",
    "failedToDownloadFile": "Datei konnte nicht heruntergeladen werden.",
    "failedToFetchUserInfo": "Benutzerinformationen konnten nicht abgerufen werden",
    "failedToFetchPlaces": "Orte konnten nicht abgerufen werden",
    "fileNotSupported": "Dateityp wird nicht unterstützt."
  },
  "regionNames": {
    "eu": "Europäische Union / European Union",
    "ch": "Schweiz / Switzerland",
    "us": "Vereinigte Staaten / United States",
    "ca": "Kanada / Canada",
    "au": "Australien / Australia",
    "hk": "Hongkong / Hong Kong",
    "sg": "Singapur / Singapore"
  },
  "zendesk": {
    "chatCouldNotBeLoaded": "Chat konnte nicht geladen werden",
    "chatCouldNotBeLoadedDescription": "Wir konnten den Support-Chat nicht laden. Dies liegt normalerweise an den Datenschutz- oder Cookie-Einstellungen Ihres Browsers. Für Anweisungen zum Aktivieren des Support-Chats klicken Sie hier: {url}."
  },
  "media": {
    "mediaUploadSuccessTitle": "Ihre Medien werden vorbereitet…",
    "mediaUploadSuccessMessage": "Aufgrund aktiver Filter oder Sortierung wird es in der aktuellen Ansicht möglicherweise nicht angezeigt.",
    "mediaViewLegacyToV2Title": "Neu gestaltete Medienseiten",
    "mediaViewV2ToLegacyTitle": "Sie verwenden das neue Design!",
    "mediaViewSwitcherDescription": "Schnellere Navigation, Filter und Sortierung.",
    "mediaDeleteConfirmation": "Möchten Sie das Medium \"{mediaName}\" wirklich löschen?",
    "multipleMediaDeleteConfirmation": "Möchten Sie wirklich {mediaCount} ausgewählte Medienelemente löschen?",
    "mediaDeleteWarning": "Durch das Löschen dieses Mediums wird es auch aus jedem Projekt entfernt.",
    "multipleMediaDeleteWarning": "Durch das Löschen dieser Medienelemente werden sie auch aus jedem Projekt entfernt, das sie verwendet.",
    "mediaFileUploadInfoMessage": "Wenn Sie diese in Ihrer aktuellen Ansicht nicht sehen, können sie durch aktive Filter oder Sortierung verborgen sein.",
    "mediaIsReady": "Ihre Medien sind bereit!",
    "mediaIsReadyWithCount": "Ihre Medien sind bereit! ({count} von {total})",
    "someFilesUploadError": "Einige Dateien konnten nicht verarbeitet werden",
    "failedUploadError": "Ihre Dateien konnten nicht verarbeitet werden. Versuchen Sie, sie erneut hochzuladen.",
    "failedUploadErrorTitle": "Wir konnten Ihre Medien nicht verarbeiten"
  },
  "led": {
    "deleteCanvasConfirmation": "Sind Sie sicher? Dadurch wird diese Canvas-Auflösung von allen Playern gelöscht.",
    "deleteCanvasWarning": "Jeder Player, der diese Canvas-Auflösung verwendet hat, muss neu konfiguriert werden, bevor Inhalte mit derselben Auflösung erneut darauf veröffentlicht werden können."
  },
  "popId": {
    "deletePopIdConfirmation": "Sind Sie sicher? Dadurch wird diese PoP-ID überall gelöscht, wo sie verwendet wird."
  },
  "tag": {
    "deleteTagConfirmation": "Sind Sie sicher? Diese Aktion löscht dieses Tag aus allen {source}.",
    "deleteTagWarning": "Dies kann sich auf Ihre Benutzerberechtigungen und Ihren Zeitplan auswirken."
  },
  "leaveAccount": {
    "leaveAccountConfirmation": "Möchten Sie das Konto [{accountName}] wirklich verlassen?",
    "leaveAccountWarning": "Wenn Sie dieses Konto verlassen, verlieren Sie den Zugriff auf das Konto und alle derzeit verfügbaren zugehörigen Produkte und Dienste."
  },
  "userProfile": {
    "permanent": "endgültig",
    "deleteUserConfirmation": "Sie sind dabei, Ihr Benutzerprofil zu löschen. Dieser Vorgang ist {permanent} und kann nicht rückgängig gemacht werden.",
    "lose": "verlieren",
    "deleteUserWarning": "Wenn Sie fortfahren, werden Sie {lose} den Zugriff auf alle mit Ihren Benutzerdaten verbundenen Konten und Produkte.\nMöchten Sie wirklich fortfahren?"
  }
}
